
const validationError = (code) => {
    return {
        valid: false,
        code: code,
    }
};

const validationSuccess = () => {
    return {
        valid: true,
    }
};

/**
 * TODO:
 * - Сделать валидацию пароля
 * - Сделать валидацию даты (на странице "Рассчитать цифровые значения")
 */
export const validations = {
    'required': (value, input) => {
        if (!value || !value.trim()) {
            return validationError('required_field');
        } else {
            return validationSuccess();
        }
    },

    'email': (value, input) => {
        const isValid = String(value)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );

        if (!isValid && String(value).length) {
            return validationError('invalid_email');
        } else {
            return validationSuccess();
        }
    },

    'number': (value, input) => {
        const isValid = value.match(/^[0-9]+$/);

        if (!isValid && String(value).length) {
            return validationError('invalid_number');
        } else {
            return validationSuccess();
        }
    },

    'number_max': (value, input) => {
        const numValue = Number(value);

        if (numValue > input.max) {
            return validationError('more_than_max');
        } else {
            return validationSuccess();
        }
    },

    'number_min': (value, input) => {
        const numValue = Number(value);

        if (numValue < input.min) {
            return validationError('less_than_min');
        } else {
            return validationSuccess();
        }
    },

    'tel': (value, input) => {
        if (input.imask.masked.isComplete || !value.length) {
            return validationSuccess();
        } else {
            return validationError('invalid_phone');
        }
    },

    'coupon_code': (value, input) => {
        if (!value.length) {
            return validationSuccess();
        }

        if (value.length < 3) {
            return validationError('coupon_min');
        } else if (value.length > 15) {
            return validationError('coupon_max');
        } else {
            return validationSuccess();
        }
    },

    'password': (value, input) => {
        const isValid = String(value)
          .toLowerCase()
          .match(
            /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
          );

        if (!isValid && String(value).length) {
            return validationError('invalid_password');
        } else {
            return validationSuccess();
        }
    }
};

export const messages = {
    'required_field': 'Это обязательное поле',
    'invalid_email': 'Некорректный E-mail',
    'invalid_number': 'Поле должно содержать только цифры',
    'less_than_min': '* - минимальное значение',
    'more_than_max': '* - максимальное значение',
    'invalid_phone': 'Некорректный номер телефона',
    'coupon_min': 'Слишком короткий код',
    'coupon_max': 'Слишком длинный код',
    'invalid_password': 'Минимум 8 символов, минимум 1 буква и 1 цифра',
};
